export interface HttpConfig {
  headers: { Accept: string };
  timeout: number;
  showSpinner: boolean;
}

export interface InfoModal {
  title: string;
  message?: string;
  messageSuccess?: string;
  messageFailed?: string;
  failedRecordLocators?: string;
  failedRecordLocatorsMessaging?: string;
}

export interface IssueActionResOptions {
  AGENT_NEGOTIATED?: string;
  AIRLINE_ARRANGED?: string;
  TRAVELER_ARRANGED?: string;
  AGENT_DETERMINED_NON_ISSUE?: string;
  TRAVELER_INDICATED_NON_ISSUE?: string;
  NO_PASSENGER_CONTACT_INFO?: string;
  NO_PASSENGER_CONTACT_MADE?: string;
  TRAVEL_RECLAIMED?: string;
  NO_ALTERNATIVE_FLIGHTS_AVAILABLE?: string;
  AGENT_UNABLE_TO_ADDRESS_IN_TIME?: string;
  LATE_ALERT?: string;
}

export const HTTP_CONFIG: HttpConfig = {
  headers: { Accept: 'application/json' },
  timeout: 60000,
  showSpinner: true,
};

export const HTTP_CONFIG_BATCH: HttpConfig = {
  headers: { Accept: 'application/json' },
  timeout: 60000,
  showSpinner: false,
};

export const TOO_MANY_MY_ISSUES = 'The My Issue List may not exceed 1000 items. Please use Issue Search to select and resolve enough issues to return it to less than 1000 open or assisting issues assigned to you.';

export const TOO_MANY_OPEN_ISSUES = 'The Open Issue List may not exceed 1000 items. Please use Issue Search to select and assist or resolve enough issues to return it to less than 1000 open issues.';

export const TOO_MANY_SEARCH_RESULTS = 'Too many results from search, please refine criteria.';

export const INFO_MODALS: { [key: string]: InfoModal } = {
  flyout: {
    title: 'ISSUES FLYOUT',
    message: 'Pop-ups appear to be blocked by the browser. Review your browser settings to allow for the issues flyout.',
  },
  batchComplete: {
    title: 'BATCH ACTION',
    messageSuccess: 'Batch processing has completed. All selected issues were processed.',
    messageFailed: 'Batch processing has completed. %FAILED% of %TOTAL% selected issues failed to process.',
    failedRecordLocators: 'The following record locators are the trips with issues that were not updated. Please select and copy the list of record locators for reference before dismissing this dialog : ',
    failedRecordLocatorsMessaging: 'Messages were not sent for issues in trips with the following record locators. Please select and copy the list of record locators for reference before dismissing this dialog : ',
  },
  batchSortByWarning: {
    title: 'WARNING',
    message: 'Sorting will result in your selected issues being dropped.',
  },
  batchShowMoreWarning: {
    title: 'WARNING',
    message: 'Showing more issues will result in your selected issues being dropped.',
  },
};

export const ISSUE_ACTION_RES_TYPES = {
  rebooked: 'REBOOKED',
  reprotected: 'REPROTECTED',
  no_changes_made: 'NO_CHANGES_MADE',
  expired: 'EXPIRED',
};

export const ISSUE_ACTION_RES_OPTIONS: { [key: string]: IssueActionResOptions } = {
  rebooked: {
    AGENT_NEGOTIATED: 'Agent Negotiated',
    AIRLINE_ARRANGED: 'Airline Arranged',
    TRAVELER_ARRANGED: 'Traveler Arranged',
  },
  reprotected: {
    AGENT_NEGOTIATED: 'Agent Negotiated',
    AIRLINE_ARRANGED: 'Airline Arranged',
    TRAVELER_ARRANGED: 'Traveler Arranged',
  },
  no_changes_made: {
    AGENT_DETERMINED_NON_ISSUE: 'Agent Determined Non-Issue',
    TRAVELER_INDICATED_NON_ISSUE: 'Traveler Indicated Non-Issue',
    NO_PASSENGER_CONTACT_INFO: 'No Passenger Contact Info',
    NO_PASSENGER_CONTACT_MADE: 'No Passenger Contact Made',
    TRAVEL_RECLAIMED: 'Travel Reclaimed',
    NO_ALTERNATIVE_FLIGHTS_AVAILABLE: 'No Alternative Flights Available',
  },
  expired: {
    AGENT_UNABLE_TO_ADDRESS_IN_TIME: 'Agent Unable to Address in Time',
    LATE_ALERT: 'Late Alert',
  },
};

export const ITINERARY_ROUTE = ':aav1Host/itinerary/Attendant/itineraryModifyDisplayAction.do?source=tripCenter&firstDepartureDate=:firstDepartureDate&lastArrivalDate=:lastArrivalDate&itineraryReferenceNumber=:itineraryReferenceNumber';

export const ISSUE_ACTION_RES_ALL_OPTIONS = {
  AGENT_NEGOTIATED: 'Agent Negotiated',
  AIRLINE_ARRANGED: 'Airline Arranged',
  TRAVELER_ARRANGED: 'Traveler Arranged',
  AGENT_DETERMINED_NON_ISSUE: 'Agent Determined Non-Issue',
  TRAVELER_INDICATED_NON_ISSUE: 'Traveler Indicated Non-Issue',
  NO_PASSENGER_CONTACT_INFO: 'No Passenger Contact Info',
  NO_PASSENGER_CONTACT_MADE: 'No Passenger Contact Made',
  TRAVEL_RECLAIMED: 'Travel Reclaimed',
  NO_ALTERNATIVE_FLIGHTS_AVAILABLE: 'No Alternative Flights Available',
  AGENT_UNABLE_TO_ADDRESS_IN_TIME: 'Agent Unable to Address in Time',
  LATE_ALERT: 'Late Alert',
  AUTO_EXPIRED: 'Auto Expired',
  SUPERSEDED: 'Superseded By Another Issue',
  FLIGHT_REMOVED: 'Flight Removed From Trip',
};

export const HTTP_CONFIG_REPORTING = {
  headers: { Accept: 'application/json' },
  timeout: 1200000,
  showSpinner: true,
};

export const PHONE_NUMBER_REGEX = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;

export const FLIGHT_HISTORY_ROUTE = ':aav1Host/itinerary/Itinerary/flightHistoryDisplay.do?flightHistoryId=:flightHistoryId';

export const HTTP_CONFIG_MOCK = {
  headers: { Accept: 'application/json' },
};